import { createSelector } from 'reselect';
import { AviaPassengerType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getSeatPrice } from '../../../SeatMap/utils';
import { getLinkedTravellersMap } from '../../../utils';
const getOrderState = (state) => state.order;
const getPassengersState = (state) => state.passengers;
export const getSelectedServicesState = (state) => state.selectedServices;
export const getSelectedServicesTypes = (payload) => createSelector(getOrderState, (order) => {
    var _a, _b, _c, _d;
    const gdsServicesMap = new Map((_d = (_c = (_b = (_a = order.additionalServices) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.map(service => [service.id, service])) !== null && _d !== void 0 ? _d : []);
    if (!gdsServicesMap.size) {
        return { id: [], rfisc: [], subType: [], type: [] };
    }
    const idSet = new Set();
    const rfiscSet = new Set();
    const typeSet = new Set();
    const subTypeSet = new Set();
    const payloadServices = Array.isArray(payload) ? payload : [payload];
    payloadServices.forEach(selectedService => {
        var _a, _b, _c, _d;
        let serviceId;
        let rfisc;
        let type;
        let subType;
        serviceId = (_a = selectedService === null || selectedService === void 0 ? void 0 : selectedService.serviceId) !== null && _a !== void 0 ? _a : (_b = selectedService === null || selectedService === void 0 ? void 0 : selectedService.service) === null || _b === void 0 ? void 0 : _b.id;
        const gdsService = gdsServicesMap.get(serviceId);
        if (gdsService) {
            rfisc = gdsService.rfisc;
            type = gdsService.type;
            if (gdsService === null || gdsService === void 0 ? void 0 : gdsService.baggageType) {
                subType = gdsService
                    .baggageType;
            }
            else if (gdsService.subType) {
                subType = gdsService.subType;
            }
        }
        else if ((_c = selectedService === null || selectedService === void 0 ? void 0 : selectedService.service) === null || _c === void 0 ? void 0 : _c.type) {
            type = (_d = selectedService === null || selectedService === void 0 ? void 0 : selectedService.service) === null || _d === void 0 ? void 0 : _d.type;
        }
        if (serviceId) {
            idSet.add(serviceId);
        }
        if (rfisc) {
            rfiscSet.add(rfisc);
        }
        if (type) {
            typeSet.add(type);
        }
        if (subType) {
            subTypeSet.add(subType);
        }
    });
    return {
        id: [...idSet],
        rfisc: [...rfiscSet],
        subType: [...subTypeSet],
        type: [...typeSet]
    };
});
export const getSelectedServices = createSelector([getSelectedServicesState, getPassengersState], (state, passengers) => {
    const passengersServices = [];
    passengers.forEach(passenger => {
        if (state[passenger.id]) {
            const passengerServices = state[passenger.id];
            const seatsServices = [], gdsServices = [];
            for (const serviceId in passengerServices) {
                if (passengerServices.hasOwnProperty(serviceId) && passengerServices[serviceId] !== null) {
                    const services = passengerServices[serviceId].filter(service => service.number > 0);
                    services.forEach(service => {
                        var _a;
                        switch ((_a = service.servicePayload) === null || _a === void 0 ? void 0 : _a.type) {
                            case OrderAdditionalServiceGdsServiceServiceType.Seat:
                                const seatServicePayload = service.servicePayload;
                                service.segments.forEach(segmentId => {
                                    seatsServices.push({
                                        segmentId,
                                        deckId: seatServicePayload.deckId,
                                        letter: seatServicePayload.letter,
                                        row: parseInt(seatServicePayload.row),
                                        type: seatServicePayload.seatType
                                    });
                                });
                                break;
                            default:
                                gdsServices.push({
                                    segmentIds: service.segments,
                                    serviceId: serviceId,
                                    count: service.number,
                                    extraValues: service.extraValues
                                });
                                break;
                        }
                    });
                }
            }
            passengersServices.push({
                travellerId: passenger.id,
                gdsServices: {
                    setServices: gdsServices
                },
                seats: seatsServices
            });
        }
    });
    return passengersServices;
});
export const getHasSelectedSeats = createSelector(getSelectedServices, selectedServices => selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices.some(travellerServices => { var _a; return ((_a = travellerServices.seats) === null || _a === void 0 ? void 0 : _a.length) > 0; }));
export const getPassengerStateCompatible = createSelector([getPassengersState, getSelectedServicesState], (passengers, selectedServices) => {
    const linkedPassengersIdsMap = getLinkedTravellersMap(passengers);
    const passengerState = passengers.map(passenger => {
        const passengerServices = selectedServices[passenger.id];
        const passengersServices = [], seats = [];
        for (const serviceId in passengerServices) {
            if (passengerServices.hasOwnProperty(serviceId) && passengerServices[serviceId]) {
                const services = passengerServices[serviceId];
                services.forEach(service => {
                    var _a;
                    if (service.number > 0) {
                        switch ((_a = service.servicePayload) === null || _a === void 0 ? void 0 : _a.type) {
                            case OrderAdditionalServiceGdsServiceServiceType.Seat:
                                const seatServicePayload = service.servicePayload;
                                const price = getSeatPrice(seatServicePayload, passenger.id);
                                service.segments.forEach(segmentId => {
                                    seats.push(Object.assign(Object.assign({}, seatServicePayload), { price,
                                        segmentId }));
                                });
                                break;
                            case OrderAdditionalServiceGdsServiceServiceType.Baggage:
                            case OrderAdditionalServiceGdsServiceServiceType.Meal:
                                passengersServices.push({
                                    segmentIds: service.segments,
                                    serviceId: serviceId,
                                    count: service.number,
                                    confirmedCount: service.servicePayload.confirmedCount
                                });
                                break;
                            case OrderAdditionalServiceGdsServiceServiceType.Vip:
                                passengersServices.push({
                                    segmentIds: service.segments,
                                    serviceId: serviceId,
                                    count: service.number,
                                    confirmedCount: service.servicePayload.confirmedCount
                                });
                        }
                    }
                });
            }
        }
        return {
            id: passenger.id,
            type: passenger.type,
            values: passenger.values,
            services: passengersServices,
            seatRestrictions: passenger.seatRestrictions,
            infantPassengerId: passenger.type === AviaPassengerType.ADT && (linkedPassengersIdsMap.get(passenger.id) || null),
            supplierTravellerType: passenger.supplierTravellerType,
            seats
        };
    });
    return passengerState;
});
